// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import AssetInviteSection from "./AssetInviteSection";
import AssetAccessListing from "./AssetAccessListing";

// Action Imports
import { AssetActions } from "../../../../actions";

// Internal Imports
import { checkAssetPermission } from "../../method";

// Destructuring
const { fetchAssetCollaboratorListAction } = AssetActions;

class AssetCollaboratorPopup extends Component {
  state = { hasEditAccess: false, isLoading: false };

  componentDidMount() {
    this._fetchAssetCollaboratorList();
    this._hasEditAccess();
  }

  _fetchAssetCollaboratorList = () => {
    const { selectedItem } = this.props;
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      this.setState({ isLoading: true });
      this.props
        .fetchAssetCollaboratorList(selectedItem.items[0].folderId)
        .then(() => {
          this.setState({ isLoading: false });
        })
        .catch(error => {
          console.error(
            `AssetCollaboratorPopup => fetchAssetCollaboratorList => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
            timeout: 3000,
          });
          this.setState({ isLoading: false });
        });
    }
  };

  _hasEditAccess = () => {
    const { selectedItem } = this.props;
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      const { accessLevel } = selectedItem.items[0];
      const hasEditPermission = checkAssetPermission(accessLevel);
      this.setState({ hasEditAccess: hasEditPermission });
    }
  };

  _closePopup = () => {
    this.props.closePopup("showAssetCollaboratorPopup", false);
  };

  _inviteCollaborators = payload => {
    this.props
      .assetAddCollaborators(payload)
      .then(() => {})
      .catch(error => {
        console.error(
          `AssetCollaboratorPopup => _addCollaborators => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Something went wrong. Please try again!",
          timeout: 3000,
        });
      });
  };

  render() {
    const { errMsg, hasEditAccess } = this.state;
    const { selectedItem, addedCollaborators } = this.props;
    const errMsgSpace = errMsg ? (
      <div className="assetmodal-error-message">{errMsg}</div>
    ) : null;
    let assetItem = null;
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      [assetItem] = selectedItem.items;
    }
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {this.state.isLoading && <Loader className="loader-bg-color" />}
        <div
          className="assetcollaboratorpopup-container assetmodal-container"
          data-test="assetcollaboratorpopup-container">
          <div
            className="assetmodal-modal-heading"
            data-test="assetcollaboratorpopup-modal-heading">
            Share {assetItem ? assetItem.folderName : ""} with Revv teammates
          </div>
          {errMsgSpace}

          {/* ----------- Add Users Section  ----------- */}
          <div className="assetcollaboratorpopup-form-wrapper">
            <AssetInviteSection
              collaborators={addedCollaborators}
              assetItem={assetItem}
              inviteCollaborators={this._inviteCollaborators}
            />
          </div>

          {/* ----------- Added Users Section  ----------- */}
          {hasEditAccess && (
            <div className="assetcollaboratorpopup-form-wrapper added-users">
              <AssetAccessListing
                collaborators={addedCollaborators}
                assetItem={assetItem}
              />
            </div>
          )}
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="createassetfolderpopup-template-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              data-test="createassetfolderpopup-template-clonetemplate-button"
              onClick={this._closePopup}>
              Share
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { assetItemCollaboratorList } = state.AssetStore;

  return {
    addedCollaborators: assetItemCollaboratorList,
  };
};

const mapDispatchToProps = {
  fetchAssetCollaboratorList: fetchAssetCollaboratorListAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetCollaboratorPopup);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetCollaboratorPopup/index.js